export default __webpack_public_path__ + "8c2120eb6c6b80d1f382ef72c4ccb5bb.svg";